import DropDownCheckbox from 'components/shared/dropdown_checkbox';
import React from 'react';
import { ProofreadEventFilterSet } from 'utils/hooks/use_proofread_event_filter';
import { booleanFilterOptions } from 'utils/utils';

type CanReserveFilterTableHeaderProps = {
  proofreadEventFilterSet: ProofreadEventFilterSet;
};

/**
 * カレンダー予約（機器の予約管理の有無）で絞り込むフィルタヘッダ
 */
export const CanReserveFilterTableHeader = ({ proofreadEventFilterSet }: CanReserveFilterTableHeaderProps) => {
  const { searchForm, handleSearch } = proofreadEventFilterSet;

  return (
    <DropDownCheckbox
      form={searchForm}
      attr={['q', 'instrumentCanReserveIn']}
      name="canReserve"
      items={booleanFilterOptions}
      title="カレンダー予約"
      onSubmit={handleSearch}
      btnStyle={{ padding: '4px 8px' }}
      showFilter
    />
  );
};

export default CanReserveFilterTableHeader;
